import { LocationDescriptorObject } from 'history'
import { RouteLocationState } from '../../../types'

export function getRedirectReferrerPath(location: LocationDescriptorObject, defaultPath = '/'): Partial<Location> {
  const { from }: RouteLocationState = location.state || { from: { pathname: defaultPath } }

  return from
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/router.ts